import React from "react";
import { Link } from "react-router-dom";
import BreadCrumbs from "./BreadCrumbs";

export default function Welcome() {
    return (
        <div>
            <BreadCrumbs/>
            <div className="flex flex-col md:mx-auto p-6 md:my-64 md:rounded-2xl shadow-xl h-screen md:max-w-screen-sm md:max-h-max gap-4 bg-white">
                <h1 className="text-3xl font-bold text-gray-900">Welcome</h1>
                <p className="text-gray-600">A simple productivity toolkit to help you stay organized and learn new things.</p>

                <div className="space-y-4 mt-2">
                    <Link to="/todo" className="block border rounded-lg p-4 hover:bg-gray-50 transition-colors">
                        <div className="flex justify-between items-center">
                            <h2 className="text-lg font-semibold text-gray-900">Todo App</h2>
                            <span className="text-gray-400">&rarr;</span>
                        </div>
                        <p className="text-sm text-gray-500 mt-1">Keep track of your tasks. Add, complete, and manage your daily to-dos in one place.</p>
                    </Link>

                    <Link to="/flashcard" className="block border rounded-lg p-4 hover:bg-gray-50 transition-colors">
                        <div className="flex justify-between items-center">
                            <h2 className="text-lg font-semibold text-gray-900">Flashcard</h2>
                            <span className="text-gray-400">&rarr;</span>
                        </div>
                        <p className="text-sm text-gray-500 mt-1">Learn new vocabulary with flashcards. Add a word and its translation, then flip through your cards to practice.</p>
                    </Link>
                </div>
            </div>
        </div>
    );
}
